module.exports = __webpack_public_path__ + "img/frigol-brand.6b3373c4.svg";